import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import SEOHead from '../components/SEOHead';
import { blogList } from '../data/blogPosts';
import { blogListStructuredData } from '../data/siteSeo';
import { mergeBlogListWithPublications } from '../lib/blogPostMerge';
import { fetchPublications } from '../lib/newsPublicationsApi';

const POSTS_PER_PAGE = 4;

const BlogPage = () => {
  const [posts, setPosts] = useState(blogList);
  const [visibleCount, setVisibleCount] = useState(POSTS_PER_PAGE);

  useEffect(() => {
    let active = true;
    fetchPublications('blog').then((items) => {
      if (active) setPosts(mergeBlogListWithPublications(blogList, items));
    }).catch(() => {
      if (active) setPosts(blogList);
    });
    return () => { active = false; };
  }, []);
  
  const currentPosts = posts.slice(0, visibleCount);
  const hasMore = visibleCount < posts.length;

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Блог | Антология — статьи об AI и технологиях для бизнеса"
        description="Статьи об искусственном интеллекте, автоматизации бизнес-процессов и технологиях для российских компаний. Экспертные материалы о внедрении AI, ИИ-агентах и Copilot-системах."
        keywords="AI для бизнеса, искусственный интеллект, блог об AI, внедрение AI, ИИ-агенты, Copilot, бизнес-автоматизация"
        canonical="https://antologia.tech/blog"
        structuredData={blogListStructuredData}
      />
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative">
          <h1 className="text-5xl font-bold mb-4">Блог</h1>
          <p className="text-xl text-muted-foreground mb-12">
            Статьи об AI, автоматизации и технологиях для бизнеса
          </p>
          
          <div className="grid gap-8 md:grid-cols-2">
            {currentPosts.map((post) => (
              <Link key={post.slug} to={`/blog/${post.slug}`} className="block">
                <Card className="h-full hover:shadow-lg hover:border-accent/50 transition-all duration-300 group overflow-hidden">
                  {post.image && (
                    <div className="aspect-video overflow-hidden">
                      <img 
                        src={post.image} 
                        alt={post.title}
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      />
                    </div>
                  )}
                  <CardHeader className="pb-4">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-sm bg-accent/10 text-accent px-3 py-1 rounded-full font-medium">
                        {post.category}
                      </span>
                      <span className="text-sm text-muted-foreground">
                        {post.readTime} чтения
                      </span>
                    </div>
                    <CardTitle className="text-2xl group-hover:text-accent transition-colors">
                      {post.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground text-lg mb-4 line-clamp-3">
                      {post.description}
                    </p>
                    <div className="flex items-center text-sm text-muted-foreground">
                      <span>{post.date}</span>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>

          {hasMore && (
            <div className="flex justify-center mt-8">
              <Button
                onClick={() => setVisibleCount(c => c + POSTS_PER_PAGE)}
                variant="outline"
                className="cursor-pointer"
              >
                Показать ещё ({posts.length - visibleCount})
              </Button>
            </div>
          )}
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage;